import SyFileDnD from "./sy-file-dnd";

export default SyFileDnD